import { useCallback, useState } from 'react';

type ModalState<ModalType, ItemType> = { type: ModalType; data: ItemType } | null;

export type useActiveModalOpenModalType<ModalType, ItemType> = (type: ModalType, data: ItemType) => () => void;

type ReturnType<ModalType, ItemType> = {
  activeModal: ModalState<ModalType, ItemType>;
  closeModal: () => void;
  openModal: useActiveModalOpenModalType<ModalType, ItemType>;
  setModalItemType: (item: ItemType) => (type: ModalType) => () => void;
};

/** it might be more commonly used */
export const useActiveModal = <ModalType, ItemType>(): ReturnType<ModalType, ItemType> => {
  const [activeModal, setActiveModal] = useState<ModalState<ModalType, ItemType>>(null);

  const closeModal = useCallback(() => setActiveModal(null), []);

  const openModal = useCallback((type: ModalType, data: ItemType) => () => setActiveModal({ type, data }), []);

  const setModalItemType = useCallback(
    (data: ItemType) => (type: ModalType) => () => {
      setActiveModal({ type, data });
    },
    []
  );

  return { activeModal, closeModal, openModal, setModalItemType };
};
